module.exports = __webpack_public_path__ + "img/leftpic2.a50dd539.png";